var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"googlebtn"},[(_vm.googleConfigured)?_c('div',{staticClass:"mx-4 ",attrs:{"id":"googleSignIn"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }